<template>
  <div class="w-100 h-100" >
    <div v-if="loading" class="h-100 w-100 d-flex justify-content-center position-fixed" style="padding-top: 250px;z-index: 6; background-color: #ffffffb8;">
      <b-spinner
          style=""
          variant="danger"
      ></b-spinner>
    </div>
    <slot></slot> <!-- 插槽用于包含 router-view -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    };
  },
  created() {
    this.$router.afterEach((to, from, next) => {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        // next();
      }, 1000); // 2秒后关闭加载遮罩
    });
  }
};
</script>

<style scoped>
.loading-overlay {
  position: relative; /* 保持相对定位 */
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
